export const extractChatPrCode = (message) => {
  const text = String(message || "");
  const explicit = text.match(/\bPR\s*[-_]\s*(\d+)\b/i);
  if (explicit) return `PR-${explicit[1]}`;
  const numbered = text.match(/\b(?:pr|purchase\s+(?:request|requisition))\s+(?:(?:details|number|no\.?|record)\s+)*(\d+)\b/i);
  return numbered ? `PR-${numbered[1]}` : null;
};

export const getChatPrRecords = (body) => {
  if (Array.isArray(body)) return body;
  if (!body || typeof body !== "object") return [];
  if (Array.isArray(body.purchase_requests)) return body.purchase_requests;
  if (body.pr_token && body.pr_code) return [body];
  if (body.data) return getChatPrRecords(body.data);
  return [];
};

export const findChatPr = (records, code) => {
  // A list response can repeat the same PR token across rows.
  const seen = new Set();
  records = records.filter((pr) => {
    if (!pr.pr_token) return true;
    if (seen.has(pr.pr_token)) return false;
    seen.add(pr.pr_token);
    return true;
  });
  const key = String(code || "").trim().toLowerCase();
  if (!key) return null;
  const exact = records.filter((pr) => String(pr.pr_code || "").trim().toLowerCase() === key);
  if (exact.length === 1) return exact[0];
  const matches = records.filter((pr) =>
    String(pr.pr_code || "").trim().toLowerCase().split("/")[0].trim() === key,
  );
  return matches.length === 1 ? matches[0] : null;
};

export async function openChatPr({ code, load, edit, onView, onEdit }) {
  const records = await load(code);
  const pr = findChatPr(records, code);
  if (!pr) throw new Error(`Purchase request ${code} was not found or is ambiguous.`);
  if (edit) {
    const approved = String(pr.pr_approval_status || "").toLowerCase() === "approved";
    const approvers = Array.isArray(pr.approvers) ? pr.approvers : [];
    if (approved || (approvers.length > 0 && approvers.every((a) => String(a.status || "").trim().toLowerCase() === "approved"))) {
      throw new Error(`Purchase request ${code} cannot be edited because it is approved.`);
    }
    onEdit(pr);
  } else {
    onView(pr);
  }
}
